
<template>
  <el-dialog
    :title="getTitle"
    :visible.sync="value"
    width="50%"
    :before-close="handleCloseDailog"
    @open="handleOpenDailog"
  >
    <el-form
      ref="entityData"
      :model="entityData"
      :rules="rules"
      label-width="150px"
      label-position="right"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="部门/科室"
            style="width: 100%;"
          >
            <el-input
              v-model="bumenName"
              style="width: 100%;"
              :disabled="true"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            label="角色"
            prop="memberRoleDictKey"
          >
            <el-select
              v-model="entityData.memberRoleDictKey"
              placeholder="请选择角色"
              clearable
            >
              <el-option
                v-for="item in selectDataD13"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
            label="负责人手机号"
            style="width: 100%;"
            prop="userPhoneNumber"
          >
            <el-input
              v-model="entityData.userPhoneNumber"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="handleCloseDailog">取 消</el-button>
      <el-button
        type="primary"
        @click="handleSaveData"
      >保  存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import pathReq from '@/api/pathlist'
import LoadingOptions from '@/components/commonSetting'
export default {
  components: {},
  props: {
    value: Boolean,
    entityId: { type: Number, default: null },
    bumenName: { type: String, default: '' },
    danweikey: { type: String, default: null },
    danweibumenkey: { type: String, default: null }

  },
  data() {
    return {
      title: '设置负责人',
      entityData: {},
      rules: {
        memberRoleDictKey: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        userPhoneNumber: [{ required: true, message: '请输入负责人手机号', trigger: 'blur' }]
      },
      selectDataD13: []
    }
  },
  computed: {
    getTitle() {
      return this.title
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.init()
  },
  methods: {
    handleOpenDailog() {
      const that = this
      that.entityData = {}
      const path = '/api/services/app/EndUserUnitMember/GetEditEndUserUnitMember'
      pathReq.toEdit(path, this.entityId).then((res) => {
        if (res.data.success) {
          that.entityData = res.data.result.entityData
          that.entityData.memberRoleDictKey = 'D1301'
          that.entityData.danWeiKey = that.danweikey ? Number(that.danweikey) : 0
          that.entityData.danWeiBuMenKey = that.danweibumenkey ? Number(that.danweibumenkey) : 0
          that.entityData.danWeiBuMenFullName = that.bumenName
        }
      })
    },
    handleCloseDailog() {
      this.$emit('input', false)
    },
    handleSaveData() {
      this.$refs.entityData.validate(valid => {
        if (valid) {
          this.entityData.id = this.entityId
          const loading = this.$loading(LoadingOptions.loadOptions)
          pathReq.postForm('/api/services/app/EndUserUnitMember/AddUnitMaster', this.entityData)
            .then(() => {
              this.entityData = {}
              loading.close()
              this.$message.success(
                '添加负责人成功'
              )
              this.$emit('save-success')
              this.$emit('input', false)
            })
        } else {
          return false
        }
      })
    },
    init() {
      pathReq.getComboxDatasById('D13').then(resp => {
        this.selectDataD13 = resp.data.result
      })
    }
  }
}
</script>
<style>

</style>
